<template>
  <div class="dropdown-menu">
  	<slot></slot>
  </div>
</template>
<script>
  export default {
  	name: 'XDropdownMenu'
  }
</script>